// extracted by mini-css-extract-plugin
export default {"suggestion":"SuggestionRow-suggestion_Mzd4p","selectLangRow":"SuggestionRow-selectLangRow_xPx17","pricesContainer":"SuggestionRow-pricesContainer_THbbx"};